import { render, staticRenderFns } from "./shopSaleStatIndex.vue?vue&type=template&id=da127546&"
import script from "./shopSaleStatIndex.vue?vue&type=script&lang=js&"
export * from "./shopSaleStatIndex.vue?vue&type=script&lang=js&"
import style0 from "./shopSaleStatIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports